import React, { useEffect, useState } from "react";
import { Table, Space, PageHeader, Button, notification, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { orderListingSaga } from "./saga";
import * as selectors from "./selectors";

const PaymentReminder = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: orderListingSaga });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchPendingOrderReport());
  }, [dispatch]);

  const paymentReport = useSelector(selectors.selectPendingOrderReport);
  const reminderInProgress = useSelector(selectors.selectRemindersInProgress);
  const orders = useSelector(selectors.selectOrders) || [];

  const [displayTemplateModal, setDisplayTemplateModal] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [companyName, setCompanyName] = useState(null);

  useEffect(() => {
    if (companyId)
      dispatch(actions.fetchPaymentPendingOrders({ companyId: companyId }));
  }, [dispatch, companyId]);

  const data = paymentReport.map((entry) => ({
    key: entry._id,
    company: entry.companyDetails[0]?.companyName,
    pending: entry.pendingCount,
  }));

  const handleCancel = () => {
    setDisplayTemplateModal(false);
    setCompanyId(null);
    setCompanyName(null);
    dispatch(actions.nullifyOrders());
  };

  const handleSendReminder = () => {
    dispatch(
      actions.sendReminder({
        id: companyId,
        onSuccess: () => {
          setCompanyId(null);
          notification.success({
            message: "Payment Remainder mails were sent successfully",
          });
        },
        onFailure: () => {
          setCompanyId(null);
          notification.error({
            message: "Error in sending payment remainder mails",
          });
        },
      })
    );
    dispatch(actions.nullifyOrders());
    setDisplayTemplateModal(false);
  };

  const columns = [
    {
      title: "Company",
      dataIndex: "company",
    },
    {
      title: "Pending Payments",
      dataIndex: "pending",
    },
    {
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            loading={reminderInProgress && !!reminderInProgress[record.key]}
            disabled={
              (reminderInProgress && !!reminderInProgress[record.key]) ||
              record.pending === 0
            }
            onClick={() => {
              setCompanyId(record.key);
              setCompanyName(record.company);
              setDisplayTemplateModal(true);
            }}
          >
            Send Reminder
          </Button>
        </Space>
      ),
      width: "200px",
    },
  ];

  return (
    <div style={{ height: "100%" }}>
      <PageHeader ghost={false} title="Payment Reminders" extra={[]} />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          overflowX: "auto",
          padding: 24,
        }}
      >
        <Table dataSource={data} columns={columns} />
      </div>
      <Modal
        title={`Sample Email for the Company Admins of ${companyName}`}
        visible={displayTemplateModal}
        onOk={handleSendReminder}
        okText="Send Reminder Mails"
        onCancel={handleCancel}
      >
        <div
          style={{ minHeight: "250px", maxHeight: "400px", overflowY: "auto" }}
        >
          <p>Hi,</p>
          <p>We hope you are well.</p>

          <p>
            This is to remind that we are yet to receive payment from your
            accounts for the following orders placed on FoodLabz.
          </p>
          {orders.length ? (
            <ul>
              {orders?.map((order) => {
                return (
                  <li>
                    {/* <Badge status="default" color="#000000" /> */}
                    {order.orderId}
                  </li>
                );
              })}
            </ul>
          ) : (
            "Loading..."
          )}
          <p>
            We would be really grateful if you could let us know when we can
            expect to receive payment.
          </p>

          <p>Thank you for your help.</p>
        </div>
      </Modal>
    </div>
  );
};

export default PaymentReminder;
